import React from 'react';
import {
  SearchStoreCategoryWrapper,
  ShopThisStoreCategoryGrid,
  ShopThisStoreCategoryRow,
} from '../styles/CategoriesArea.style';

export const L2CategoriesSkeleton = () => {
  return (
    <ShopThisStoreCategoryGrid>
      <ShopThisStoreCategoryRow className="categories-l2-row-desktop" />
    </ShopThisStoreCategoryGrid>
  );
};

export const L1CategoriesSkeleton = () => {
  return (
    <ShopThisStoreCategoryGrid>
      <ShopThisStoreCategoryRow className="categories-l1-row-desktop" />
    </ShopThisStoreCategoryGrid>
  );
};

export const StoreCategoryNavigationSkeleton = () => {
  return (
    <>
      <L1CategoriesSkeleton />
      <L2CategoriesSkeleton />
    </>
  );
};

export const CategoriesFilterSkeleton = () => {
  return (
    <SearchStoreCategoryWrapper>
      <StoreCategoryNavigationSkeleton />
    </SearchStoreCategoryWrapper>
  );
};

export default CategoriesFilterSkeleton;
